import React from 'react';
import {connect} from 'react-redux';
import {
    closePaymentPopup,
    moneyGivenAdd,
    moneyGivenConnetToEnd,
    paymentChangeRadio,
    discountChangeRadio,
    resetPaymentMoney,
    clearDiscount,
    setPaymentItemsWithZeroDiscount
} from '../../../../common/paymentPopup/actions';
import {selectCashbox, resetSelectedCashboxToDefault} from '../../../../common/cashboxes/actions';
import {fetchHabitueDetail} from '../../../../common/menu/credit/debtDetail/actions';
import {changeMenuPanel} from '../../../../common/menu/actions';
import AbstractPaymentPopup from '../../../paymentPopup/AbstractPaymentPopup';
import {fetchPayDebt} from '../../../../common/menu/credit/debtDetail/actions';
import {setAllowSale, setForbidSale} from '../../../../common/categories/actions';
import {List, fromJS, Map} from 'immutable';
import {selectReceiptToPrintOnline} from '../../../../common/storno/actions';
import {
    manageReceipt,
    print,
    countTotalItemsPrice,
    countVatsItesPrices,
    preparePrintArray, isNeedArrayPrint
} from '../../../../common/lib/util';

class CreditPaymentPopup extends AbstractPaymentPopup {

    static propTypes = {
        msg: React.PropTypes.object,
        orderToPrint: React.PropTypes.object,
        cashboxes: React.PropTypes.object,
        id: React.PropTypes.string,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        max: React.PropTypes.number,
        oneDebtToPay: React.PropTypes.number,
        lastBillNum: React.PropTypes.number,
        debtsToPay: React.PropTypes.object,
        selectedCashbox: React.PropTypes.object,
        selectedBills: React.PropTypes.object,
        branch: React.PropTypes.object,
        bills: React.PropTypes.object,
        bar: React.PropTypes.object,
        organization: React.PropTypes.object,
        deviceId: React.PropTypes.number,
        barId: React.PropTypes.number,
        changeMenuPanel: React.PropTypes.func,
        fetchPayDebt: React.PropTypes.func,
        fetchHabitueDetail: React.PropTypes.func,
        selectReceiptToPrintOnline: React.PropTypes.func,
        setForbidSale: React.PropTypes.func,
        setAllowSale: React.PropTypes.func,
        menuTypes: React.PropTypes.object,
        vats: React.PropTypes.object,
        discount: React.PropTypes.number,
        items: React.PropTypes.object,
        silentPrint: React.PropTypes.bool,
        billPrintAllowed: React.PropTypes.bool,
        printType: React.PropTypes.string,
        printAddress: React.PropTypes.string,
        printLength: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.redirectAfterPay = this.redirectAfterPay.bind(this);
        this.addDiscount = this.addDiscount.bind(this);
        this.print = this.print.bind(this);
    }

    redirectAfterPay(error = false) {
        const {max, oneDebtToPay, fetchHabitueDetail, id, limit, page, changeMenuPanel, menuTypes} = this.props;

        if (!error && oneDebtToPay !== null && max > 1) {
            fetchHabitueDetail(id, limit, page);
        } else {
            changeMenuPanel(menuTypes.CREDITS);
        }

        this.closePopup();
    }

    print() {
        const {
            branch, setAllowSale, printType, bar, organization, orderToPrint, cashboxes, deviceId, silentPrint,
            printAddress, printLength, billPrintAllowed, msg
        } = this.props;

        const printArray = !!isNeedArrayPrint(printType)
            ? preparePrintArray(bar, organization, orderToPrint, branch, cashboxes, null, null, null, deviceId, msg)
            : null;

        print(printType, printAddress, printArray, silentPrint, printLength, true, billPrintAllowed);

        window.setTimeout(function () {
            setAllowSale();
        }, 2000);

    }

    checkAndDoOrder() {
        const {
            oneDebtToPay, debtsToPay, fetchPayDebt, deviceId, barId, branch, lastBillNum, selectedCashbox,
            discount, setAllowSale, setForbidSale, selectReceiptToPrintOnline, vats, items
        } = this.props;

        let ids;
        let paymentType = selectedCashbox.get('type');
        let cashboxId = selectedCashbox.get('id');

        if (oneDebtToPay !== null) {
            ids = List.of(oneDebtToPay);
        } else {
            ids = debtsToPay.get('billsIds');
        }

        const branchId = branch.get('eetBranchId') == null ? '' : branch.get('eetBranchId');
        const number = lastBillNum + 1;
        const sellTime = new Date();
        const vatsMap = countVatsItesPrices(vats, items);

        setForbidSale();
        fetchPayDebt({ids, branchId, discount, paymentType, cashboxId, deviceId, barId, number, sellTime, items})
            .payload.promise
            .then(res => {
                selectReceiptToPrintOnline(manageReceipt(fromJS(res.data), vats, vatsMap));
                const print = this.print;
                window.setTimeout(function () {
                    print();
                }, 200);
                this.redirectAfterPay(false);
            })
            .catch(res => {
                setAllowSale();
                this.redirectAfterPay(true);
            });
    }

    addDiscount(items) {
        let map = Map();
        items.forEach(item => {
            map = map.set(item.get('id'), item.set('discount', 0))
        });
        return map;
    }

    getTotalPricePreRound() {
        const {oneDebtToPay, bills, debtsToPay} = this.props;
        if (oneDebtToPay === null) {
            return countTotalItemsPrice(debtsToPay.get('items'));
        } else if (!!bills) {
            const bill = bills.find(t => t.get('id') === oneDebtToPay);
            return !bill ? 0 : bill.get('totalAmount');
        } else {
            return 0;
        }
    }

    getItemsToPrint() {
        const {oneDebtToPay, bills, debtsToPay} = this.props;
        if (oneDebtToPay === null) {
            return this.addDiscount(debtsToPay.get('items'));
        } else if (!!bills) {
            const bill = bills.find(t => t.get('id') === oneDebtToPay);
            return !bill ? List() : this.addDiscount(bill.get('items'));
        } else {
            return List();
        }
    }

}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    orderToPrint: state.categories.get('orderToPrint'),
    cashboxes: state.cashboxes.get('cashboxes'),
    organization: state.categories.get('organization'),
    bar: state.bars.get('bar'),
    selectedCashbox: state.cashboxes.get('selectedCashbox'),
    defaultCashbox: state.cashboxes.get('defaultCashbox'),
    payingInProgress: state.categories.get('payingInProgress'),
    onlineState: state.categories.get('onlineState'),
    discount: state.paymentPopup.get('discount'),
    discountRadio: state.paymentPopup.get('discountRadio'),
    discountCurrency: state.paymentPopup.get('discountCurrency'),
    paymentRadio: state.paymentPopup.get('paymentRadio'),
    paymentRadioTypes: state.paymentPopup.get('paymentRadioTypes'),
    moneyGiven: state.paymentPopup.get('moneyGiven'),
    oneDebtToPay: state.menuDebtDetail.get('oneDebtToPay'),
    bills: state.menuDebtDetail.get('bills'),
    debtsToPay: state.menuDebtDetail.get('debtsToPay'),
    max: state.menuDebtDetail.get('max'),
    deviceId: state.device.get('id'),
    barId: state.bars.getIn(['bar', 'id']),
    branch: state.branches.get('branch'),
    lastBillNum: state.categories.get('lastBillNum'),
    id: state.menuDebtDetail.get('id'),
    limit: state.menuDebtDetail.get('limit'),
    page: state.menuDebtDetail.get('page'),
    menuTypes: state.menu.get('menuTypes'),
    silentPrint: state.device.get('silentPrint'),
    printType: state.device.get('printType'),
    billPrintAllowed: state.device.get('billPrint'),
    printAddress: state.device.get('printAddress'),
    vats: state.categories.get('vats'),
    selectedBills: state.menuDebtDetail.get('selectedBills'),
    selectedItemId: state.paymentPopup.get('selectedItemId'),
    items: state.paymentPopup.get('items'),
    discountPrice: state.paymentPopup.get('discountPrice'),
    printLength: state.device.get('printLength')
}), {
    closePaymentPopup, moneyGivenAdd, moneyGivenConnetToEnd, resetSelectedCashboxToDefault, fetchHabitueDetail,
    selectCashbox, paymentChangeRadio, resetPaymentMoney, clearDiscount, fetchPayDebt, setAllowSale, changeMenuPanel,
    setForbidSale, selectReceiptToPrintOnline, setPaymentItemsWithZeroDiscount, discountChangeRadio
})(CreditPaymentPopup)



// WEBPACK FOOTER //
// ./src/browser/menu/credit/debtDetail/CreditPaymentPopup.js